import {Component, Input, OnInit} from '@angular/core';
import {
  Aangifte,
  AangifteRapport, BokkzAlgDataService,
  BokkzIbDataService,
  IncomeTaxEntity,
  OpbouwGiften,
  SpecificatieGiften
} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-giften',
  templateUrl: './spec-giften.component.html',
  styleUrls: ['./spec-giften.component.scss'],
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class SpecGiftenComponent implements OnInit {
    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    private currentAangifte = {} as Aangifte;
    private partnerAangifte = {} as Aangifte;

    specGiftenFormGroup = this.fb.group<AangifteRapport>({});
    specGiften = {} as AangifteRapport;
    public giftenMaxOpbvInkomen = false;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specGiftenFormGroup = this.fb.group<AangifteRapport>(({
            specificatieGiften: this.fb.group<SpecificatieGiften>(({
                opbouw: this.fb.group<OpbouwGiften>(({
                    aftrekbareGiften: null as unknown as number,
                    gewoneGiften: null as unknown as number,
                    gewoneGiftenCultureel: null as unknown as number,
                    totaalGewoneGiften: null as unknown as number,
                    aftrekbareGewoneGiften: null as unknown as number,
                    periodiekeGiften: null as unknown as number,
                    periodiekeGiftenCultureel: null as unknown as number,
                    totaalPeriodiekeGiften: null as unknown as number,
                    verhogingGewoneCultureleGiften: null as unknown as number,
                    verhogingPeriodiekeCultureleGiften: null as unknown as number,
                    aftrekbarePeriodiekeGiften: null as unknown as number,
                    giftenVoorDrempel: null as unknown as number,
                    drempelGiften: null as unknown as number,
                    totaalGiftenaftrek: null as unknown as number,
                    aandeelGiftenaftrek: null as unknown as number,
                } as OpbouwGiften))
            } as SpecificatieGiften))
        } as AangifteRapport))
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specGiften = value;
                    const opbouw = this.specGiften?.specificatieGiften?.opbouw;
                    if (opbouw) {
                        const gewoneGiften = opbouw.gewoneGiften || 0;
                        const gewoneGiftenCultureel = opbouw.gewoneGiftenCultureel || 0;
                        opbouw['totaalGewoneGiften'] = gewoneGiften + gewoneGiftenCultureel;

                        const verhogingGewoneCultureleGiften = opbouw.verhogingGewoneCultureleGiften || 0;
                        opbouw['giftenVoorDrempel'] = opbouw.totaalGewoneGiften + verhogingGewoneCultureleGiften;

                        const drempelGewoneGiften = opbouw.drempelGiften || 0;
                        const berekendeAftrekbareGewoneGiften = gewoneGiften + gewoneGiftenCultureel + verhogingGewoneCultureleGiften - drempelGewoneGiften;
                        const aftrekbareGewoneEnCultureleGiften = opbouw.aftrekbareGewoneGiften || 0;
                        if (aftrekbareGewoneEnCultureleGiften < berekendeAftrekbareGewoneGiften) {
                            this.giftenMaxOpbvInkomen = true
                        }

                        if (berekendeAftrekbareGewoneGiften < 1) {
                            opbouw['aftrekbareGewoneGiften'] = 0;
                        }
                    }
                    this.specGiftenFormGroup.patchValue(this.specGiften)
                    this.disableFormGroup(this.specGiftenFormGroup);
                });
            }
        });
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    protected readonly Object = Object;
}

